export { default } from "./TransactionDetailInfo";
